import { HealthIndicator } from '../../models/health.model';

function isSevereRow(rowParams) {
    if (!rowParams.data) {
        return false;
    }
    var severeIndicator: HealthIndicator = rowParams.data.statusIndicator;
    return severeIndicator == HealthIndicator.MOST_SEVERE;
}

export const dashboardRowClassRules = {
    "ag-grid-dashboard-row": () => true,
    "ag-grid-severe-row": (params) => {
        //debugger
        return isSevereRow(params)
    },
    "ag-grid-non-severe-row": (params) => !isSevereRow(params),
    "ag-dashboard-grid-row-with-hover": (params) => {
        // no hover for row if there is either cell hover enabled or row hover explicitly disabled
        return !(params.context && params.context.enableCellHover) &&
            (!params.context || !params.context.disableRowHover)
    },
    "ag-dashboard-grid-cell-hover-row": (params) => {
        // 
        return params.context && params.context.enableCellHover
    },
};